import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";

const JobListingsContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10rem;
  position: relative;
  height: 100%;
  width: 100%;
  margin: 2rem auto;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    width: 1px;
    height: 90%;
    background-color: #000;
    transform: translateX(-50%);
  }

  @media (max-width: 768px) {
    gap: 3rem;
  }
`;
const JobListingsTitle = styled("div")`
  color: #000;
  text-align: center;
  font-family: Montserrat;
  font-size: 2.063rem; /*33px */
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 17px;
  }
`;

const JobListingsLocation = styled("div")`
  color: #000;
  text-align: center;
  font-family: Montserrat;
  font-size: 2.063rem; /*33px */
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin-top: 1vw;
  @media (max-width: 768px) {
    font-size: 15px;
  }
`;


const ApplyButton = styled("button")`
  background-color: #1d00c4;
  color: #fff;
  padding: 0.7rem 3rem;
  font-size: 1.5rem; /* 24px */
  font-weight: 500;
  text-transform: none;
  margin-top: 1rem;
  border: 0.9px solid #1d00c4;
  align-self: center;
  position: relative;
  box-shadow: none;
  color: #FFF;
  text-align: center;
  font-family: Radikal;
  font-size: 1.5rem; /*24px*/
  font-weight: 500;
  margin: 2vw auto;
  border-radius: 18px !important;
  &::after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    border-radius: 17px;
    border: 3.5px solid #fff;
  }
  @media (max-width: 768px) {
    margin: 4vw auto;
    font-size: 0.75rem;
    padding: 0.7rem 2rem;
  }
`;



const cardData = [
  { title: "Lead Generation", location: "(Bengaluru)" },
  { title: "Field Specialists", location: "(PAN India)" },
];

const JobListings = () => {
    const navigate = useNavigate(); 

    const handleApplyClick = () => {
      navigate("/careers-form"); 
    };
  
  return (
    <JobListingsContainer>
      {cardData.map((job, index) => (
        <Box textAlign="center" key={index}>
          <JobListingsTitle>{job.title}</JobListingsTitle>
          <JobListingsLocation>{job.location}</JobListingsLocation>
          <ApplyButton onClick={handleApplyClick}>Apply</ApplyButton>
        </Box>
      ))}
    </JobListingsContainer>
  );
};

export default JobListings;
